export default __webpack_public_path__ + "ddk-logo.e7acf7b3.png";